import { createRouter, createWebHistory } from "vue-router";
import i18nService from "./i18n"

import HomePage from "./pages/HomePage.vue";
// import CoursePage from "./pages/CoursesPage.vue";
// import AboutUsPage from "./pages/AboutUsPage.vue";
// import ContactPage from "./pages/ContactPage.vue";
// import Learn2EarnContestPage from "./pages/Learn2EarnContestPage.vue"
// import FintriviaPage from "./pages/FintriviaPage.vue"
// import PricingPage from "./pages/PricingPage.vue";
// import UnderstandingOptions from "./pages/UnderstandingOptions.vue";
// import StockPicking from "./pages/StockPicking.vue";
// import PortfolioManagement from "./pages/PortfolioManagement.vue";
// import BondStrategies from "./pages/BondStrategies.vue";
// import Foundation from "./pages/Foundation.vue";
import LearnByDoing from "./pages/LearnByDoing.vue";

const router = createRouter({
  history: createWebHistory(),
//   scrollBehavior: function(to, from, savedPosition) {//eslint-disable-line
//     if (to.hash) {
//        return {el: to.hash}
//     } else {
//         return { x: 0, y: 0 }
//     }
// },

  routes: [
    { path: "/", alias: "/home",
      component: HomePage ,
      name: "home",
    },
    { path: "/learn-by-doing",
      component: LearnByDoing ,
      name: "learn-by-doing",
    },
    {
      path: "/courses",
       component: () => import("./pages/CoursesPage.vue"),
      name: "courses",
    },
     {
      path: "/courses/understanding-options",
       component: () => import("./pages/UnderstandingOptions.vue"),
      name: "understanding-options",
    },
    {
      path: "/courses/stock-picking",
      component: () => import("./pages/StockPicking.vue"),
      name: "stock-picking",
    },
     {
      path: "/courses/portfolio-management",
       component: () => import("./pages/PortfolioManagement.vue"),
      name: "portfolio-management",
    },
     {
      path: "/courses/bond-strategies",
      component: () => import("./pages/BondStrategies.vue"),
      name: "bond-strategies",
    },
    {
      path: "/courses/foundation",
      component: () => import("./pages/Foundation.vue"),
      name: "foundation-course",
    },
    {
      path: "/about-us",
       component: () => import("./pages/AboutUsPage.vue"),
      name: "about-us",
    },
    // {
    //   path: "/creators",
    //   component: () => import("./pages/CreatorPage.vue"),
    //   name: "creators",
    // },
    {
      path: "/pricing",
       component: () => import("./pages/PricingPage.vue"),
      name: "pricing",
    },
    // {
    //   path: "/contest",
    //   component: () => import("./pages/ContestPage.vue"),
    //   name: "contest",
    //   children: [
    //     {
    //       path: "growth2022",
    //       component: Growth2022,
    //       name: "growth2022",
    //     },
    //   ],
    // },
     {
      path: "/learn2earn",
       component: () => import("./pages/Learn2EarnContestPage.vue"),
      name: "learn2earnContest",
    },
    {
      path: "/well-vrsd",
      component: () => import("./pages/NewsletterPage.vue"),
      name: "newsletter",
    },
    {
      path: "/terms",
      component: () => import("./pages/TermsPage.vue"),
      name: "terms",
    },
    {
      path: "/privacy",
      component: () => import("./pages/PrivacyPage.vue"),
      name: "privacy",
    },
    {
      path: "/contact",
       component: () => import("./pages/ContactPage.vue"),
      name: "contact",
    },
   
    { path: "/fintrivia",
       component: () => import("./pages/FintriviaPage.vue"),
      name: "fintrivia",
    },
    // {
    //   path: "/showdown-rules",
    //   component: () => import("./pages/ShowdownRulesPage.vue"),
    //   name: "showdown-rules",
    // },
    {
      path: "/fintrivia-rules",
      component: () => import("./pages/FinTriviaRulesPage.vue"),
      name: "fintrivia-rules",
    },
    {
      path: "/learn2earn-rules",
      component: () => import("./pages/Learn2EarnRulesPage.vue"),
      name: "learn2earn-rules",
    },
    {
      path: "/referrals",
      component: () => import("./pages/ReferralProgramPage.vue"),
      name: "referrals",
    },
    //{ path: "/:notFound(.*)", redirect: "/home" },
  ],
  linkActiveClass: "active",
});

router.beforeEach(async (to, from, next) => {//eslint-disable-line
  i18nService.initLocale();
  
  return next()
});
export default router;
